<button type="submit" class="btn {{_class}}">
  <!-- colocar icone -->
  {{_label}}
</button>